import { MESES, VENTA_PIPELINE_SERIES } from "./pygAnaliticoBuild";

/** Filas mensuales apiladas por componente de venta (M1…M12). */
export const buildPipelineVentaChartData = (breakdown) => {
  if (!breakdown) return [];

  return MESES.map((mes, i) => {
    const mesNum = parseInt(mes, 10);
    const row = { mes: `M${i + 1}` };
    VENTA_PIPELINE_SERIES.forEach(({ key }) => {
      row[key] = Number(breakdown[key]?.mes?.[mesNum] ?? 0);
    });
    return row;
  });
};

/** Acumulado mes a mes de cada componente. */
export const buildPipelineVentaAcumChartData = (breakdown) => {
  if (!breakdown) return [];

  const acums = Object.fromEntries(
    VENTA_PIPELINE_SERIES.map(({ key }) => [key, 0]),
  );

  return MESES.map((mes, i) => {
    const mesNum = parseInt(mes, 10);
    const row = { mes: `M${i + 1}` };
    VENTA_PIPELINE_SERIES.forEach(({ key }) => {
      acums[key] += Number(breakdown[key]?.mes?.[mesNum] ?? 0);
      row[key] = acums[key];
    });
    return row;
  });
};
